import { render, staticRenderFns } from "./czbaobiao.vue?vue&type=template&id=9d60fa60&scoped=true"
import script from "./czbaobiao.vue?vue&type=script&lang=js"
export * from "./czbaobiao.vue?vue&type=script&lang=js"
import style0 from "./czbaobiao.vue?vue&type=style&index=0&id=9d60fa60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d60fa60",
  null
  
)

export default component.exports